import clsx from 'clsx'
import React from 'react'

const CircularProgress = ({ className = '' }: { className?: string }) => {
  return <div className={clsx(className, 'loading')}></div>
}

export default CircularProgress
